import { memo, useEffect } from 'react';
import { TextStyle } from 'react-native';
import {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import { Variants as TextVariants } from '../../Text/Text.content';
import { INPUT_CONTAINER_STYLE, INPUT_STYLE } from '../Input.content';
import { FloatingPlaceholderProps } from './FloatingPlaceholder.types';
import Text from '../../Text/Text';
import useStyle from '../../../hooks/useStyle';
import Box from '../../Box/Box';

function FloatingPlaceholder({ direction, ...rest }: FloatingPlaceholderProps) {
  const textVariant = direction === 'up' ? 'input-label' : 'input-text';
  const { height, lineHeight, fontSize } = useStyle<TextStyle>({
    ...INPUT_CONTAINER_STYLE.default,
    ...TextVariants[textVariant],
  });
  const textSize = useSharedValue(1);
  const textHeight = useSharedValue(0);
  const translateY = useSharedValue(0);
  const animatedStyle = useAnimatedStyle(() => ({
    fontSize: textSize.value,
    lineHeight: textHeight.value,
    transform: [
      {
        translateY: translateY.value,
      },
    ],
  }));

  useEffect(() => {
    textSize.value = withTiming(Number(fontSize));
    textHeight.value = withTiming(Number(lineHeight));
    translateY.value = withTiming(
      direction === 'up' ? 8 : Number(height) / 2 - Number(lineHeight) / 2,
    );
  }, [
    direction,
    fontSize,
    lineHeight,
    height,
    textSize,
    textHeight,
    translateY,
  ]);

  return (
    <Box pointerEvents="none" position="absolute" width="100%">
      <Text
        {...rest}
        position="absolute"
        color="darkSurfaceSecondary"
        animatedStyle={animatedStyle}
        variant={textVariant}
        paddingHorizontal={INPUT_STYLE.default.paddingHorizontal}
      />
    </Box>
  );
}

export default memo(FloatingPlaceholder);
